import { Router } from '@angular/router';
import { DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent, MatDatepicker } from '@angular/material/datepicker';
import { SharedService } from '../../services/shared.service';
import { IncidentReportService } from '../../services/incident-report.service';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class IncidentReportStatisticsComponent implements OnInit {
  dateStart: string;
  dateStartInput: Date;
  dateEnd: string;
  dateEndInput: Date;
  test: Date;
  events: string[] = [];
  dateStartForm = new FormControl(moment());
  dateEndForm = new FormControl(moment());
  showErrorMessage: boolean;
  errorMessage: string;
  facilityId: number;

  incidentReportStatisticVos: any[];

  constructor(private sharedService: SharedService,
    private incidentReportService: IncidentReportService,
    private router: Router,
    public datepipe: DatePipe) { }

  ngOnInit() {
    this.facilityId = 0;
    this.sharedService.reloadUserPrivileges();
    this.loadPeriod();
    this.loadIncidentReportStatisticVos();
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  onActionFacilityChange() {
    this.loadIncidentReportStatisticVos()
  }

  chosenYearHandlerStartDate(normalizedYear: Moment) {
    const ctrlValue = this.dateStartForm.value;
    ctrlValue.year(normalizedYear.year());
    this.dateStartForm.setValue(ctrlValue);
  }

  chosenMonthHandlerStartDate(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.dateStartForm.value;
    ctrlValue.month(normalizedMonth.month());
    this.dateStartForm.setValue(ctrlValue);
    datepicker.close();
    this.dateStartInput = new Date(Date.parse(this.dateStartForm.value.toString()));
    this.dateStart = this.datepipe.transform(this.dateStartInput, 'yyyy-MM');
    this.loadIncidentReportStatisticVos();
  }

  chosenYearHandlerEndDate(normalizedYear: Moment) {
    const ctrlValue = this.dateEndForm.value;
    ctrlValue.year(normalizedYear.year());
    this.dateEndForm.setValue(ctrlValue);
  }

  chosenMonthHandlerEndDate(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.dateEndForm.value;
    ctrlValue.month(normalizedMonth.month());
    this.dateEndForm.setValue(ctrlValue);
    datepicker.close();
    this.dateEndInput = new Date(Date.parse(this.dateEndForm.value.toString()));
    this.dateEnd = this.datepipe.transform(this.dateEndInput, 'yyyy-MM');
    this.loadIncidentReportStatisticVos();
  }

  loadIncidentReportStatisticVos() {
    this.showErrorMessage = false;
    var resultFieldsValidation = this.validateDate();
    if (resultFieldsValidation.length == 0) {
      this.incidentReportService.getIncidentReportStatisticVos(this.sharedService.pharmacyId, this.facilityId, this.sharedService.getUserId(), this.dateStart, this.dateEnd).subscribe(data => {
        this.incidentReportStatisticVos = data;
      });
    } else
      this.loadErrorMessage(resultFieldsValidation.join(" "));
  }

  validateDate(): string[] {
    var errors: string[] = [];
    if (this.dateEnd < this.dateStart)
      errors.push("The End Date must be greater then Start Date!")
    return errors;
  }

  loadPeriod() {
    var today = new Date();
    this.dateStartInput = new Date(today.getFullYear(), today.getMonth(), 1);
    this.dateStart = this.datepipe.transform(this.dateStartInput, 'yyyy-MM');
    this.dateEndInput = today;
    this.dateEnd = this.datepipe.transform(this.dateEndInput, 'yyyy-MM');
  }

  public exportToPdf() {
    var pageTitle = "IncidentReport";
    this.router.navigate([]).then(result => { window.open('report/IncidentReport/' + this.dateStart + '/' + this.dateEnd + '/' + pageTitle, '_blank'); });
  }

  exportToExcel(): void {
    if (!this.incidentReportStatisticVos || this.incidentReportStatisticVos.length === 0) {
      return;
    }
    const rows: any[][] = [];
    for (const vo of this.incidentReportStatisticVos) {
      rows.push(['Facility', vo.facility || '']);
      rows.push([]);
      const monthLabels = (vo.months || []).map((m: any) => {
        const d = typeof m === 'string' ? new Date(m) : m;
        return this.datepipe.transform(d, 'MMM. yyyy') || '';
      });
      for (const group of vo.incidentReportStatisticGroupVos || []) {
        rows.push([group.title || ''].concat(monthLabels));
        for (const item of group.incidentReportStatisticGroupItemVos || []) {
          const quantities = (item.incidentReportStatisticGroupItemMonthVos || []).map((m: any) => m.quantity != null ? m.quantity : '');
          rows.push([item.title || ''].concat(quantities));
        }
        rows.push([]);
      }
      rows.push([]);
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);
    const firstVo = this.incidentReportStatisticVos[0];
    const monthCount = firstVo && firstVo.months ? firstVo.months.length : 12;
    worksheet['!cols'] = [{ wch: 40 }].concat(Array(monthCount).fill(null).map(() => ({ wch: 12 })));
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Incident Report Statistics': worksheet },
      SheetNames: ['Incident Report Statistics']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    let facilityLabel = 'AllFacilities';
    if (this.facilityId !== 0 && this.sharedService.facilities) {
      const found = this.sharedService.facilities.find((f: any) => f.id === this.facilityId);
      facilityLabel = (found && found.name) ? found.name : 'Facility';
    }
    const raw = String(facilityLabel).trim();
    const safeName = (raw
      .replace(/[/\\:*?"<>|\x00-\x1f]/g, '_')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '')
      .trim()) || 'Facility';
    const fileName = `IncidentReportStatistics_${this.dateStart}_${this.dateEnd}_${safeName}.xlsx`;
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }
}
